import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import Modal from 'react-modal'
import Select from 'react-select';

import downArrow from '../media/down-arrow.png'

const Main = (props) => {

    const [taxMessage, setTaxMessage] = useState(false)
    const [noticePopup, setNoticePopup] = useState(-1)

    console.log(props)

    const stateOptions = [
        { value: 'AL', label: 'AL' }, { value: 'AK', label: 'AK' }, { value: 'AZ', label: 'AZ' }, { value: 'AR', label: 'AR' }, { value: 'CA', label: 'CA' },
        { value: 'CO', label: 'CO' }, { value: 'CT', label: 'CT' }, { value: 'DE', label: 'DE' }, { value: 'FL', label: 'FL' }, { value: 'GA', label: 'GA' },
        { value: 'HI', label: 'HI' }, { value: 'ID', label: 'ID' }, { value: 'IL', label: 'IL' }, { value: 'IN', label: 'IN' }, { value: 'IA', label: 'IA' },
        { value: 'KS', label: 'KS' }, { value: 'KY', label: 'KY' }, { value: 'LA', label: 'LA' }, { value: 'ME', label: 'ME' }, { value: 'MD', label: 'MD' },
        { value: 'MA', label: 'MA' }, { value: 'MI', label: 'MI' }, { value: 'MN', label: 'MN' }, { value: 'MS', label: 'MS' }, { value: 'MO', label: 'MO' },
        { value: 'MT', label: 'MT' }, { value: 'NE', label: 'NE' }, { value: 'NV', label: 'NV' }, { value: 'NH', label: 'NH' }, { value: 'NJ', label: 'NJ' },
        { value: 'NM', label: 'NM' }, { value: 'NY', label: 'NY' }, { value: 'NC', label: 'NC' }, { value: 'ND', label: 'ND' }, { value: 'OH', label: 'OH' },
        { value: 'OK', label: 'OK' }, { value: 'OR', label: 'OR' }, { value: 'PA', label: 'PA' }, { value: 'RI', label: 'RI' }, { value: 'SC', label: 'SC' },
        { value: 'SD', label: 'SD' }, { value: 'TN', label: 'TN' }, { value: 'TX', label: 'TX' }, { value: 'UT', label: 'UT' }, { value: 'VT', label: 'VT' },
        { value: 'VA', label: 'VA' }, { value: 'WA', label: 'WA' }, { value: 'WV', label: 'WV' }, { value: 'WI', label: 'WI' }, { value: 'WY', label: 'WY' }
    ];

    const creditOptions = [{value: 1, label: 'Tier 1 (781-850)'},{value: 2, label: 'Tier 2 (661-780)'},{value: 3, label: 'Tier 3 (601-660)'},{value: 4, label: 'Tier 4 (501-600)'},{value: 1, label: 'Tier 5 (300-500)'},]

    const [selectedState, setSelectedState] = useState('')
    const [selectedCredit, setSelectedCredit] = useState(-1)

    const customStyles = {
        menu: (provided) => ({
          ...provided,
          maxHeight: '200px', // Set max height here
          overflowY: 'auto',  // Add scroll if the content exceeds max height
        }),
      };

    const getRates = (state, addTaxFees) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }

        window.apiRequest('/state/tax/' + state.value, requestOptions, (result, status) => {   
            console.log(result)
            if (status === 200)
            {
                localStorage.setItem('state', state.value) 
                localStorage.setItem('tax', result)
                localStorage.setItem('includeTaxFees', addTaxFees)
                calculateLeaseValues(props.car, addTaxFees, (result / 100))
                calculateFinanceValues(props.car, addTaxFees, (result / 100))
            } else {}
        })
    }

    const calculateLeaseValues = (car, taxFees, tax) => {
        const dpAmount = 0.05
        const depreciation = car.discounted_msrp - car.residual
        const leaseCharge = (car.msrp + car.residual)*car.money_factor;
        let fees = props?.car?.fees?.reduce((total, item) => total + item.cost, 0)
        if (taxFees)
        {
            const monthlyPayment = ((depreciation - (car.discounted_msrp * dpAmount)) * (1 + tax) + fees) / car.lease_term_length + leaseCharge;
            props.setLeaseMonthly(monthlyPayment.toFixed(2));
            props.setLeaseDown((car.discounted_msrp * dpAmount).toFixed(2));
        }
        else
        {
            props.setLeaseMonthly((((car.discounted_msrp - car.residual) - (car.discounted_msrp * dpAmount))/car.lease_term_length).toFixed(2))
            props.setLeaseDown((car.discounted_msrp * dpAmount).toFixed(2))
        }
    }

    const calculateFinanceInterest = (car, dpAmount) => {
        const principal = car.discounted_msrp - (car.discounted_msrp * dpAmount);
        const annualInterestRate = car.interest_rate
        const monthlyRate = annualInterestRate / 12;
        const termLength = car.finance_term_length;
    
        // Calculate the monthly payment using the amortized loan formula
        const monthlyPayment = (principal * monthlyRate * Math.pow(1 + monthlyRate, termLength)) /
                               (Math.pow(1 + monthlyRate, termLength) - 1);
    
        // Calculate the total payments over the term
        const totalPayments = monthlyPayment * termLength;
    
        // Calculate the total interest by subtracting the principal from the total payments
        const totalInterest = totalPayments - principal;
        console.log(totalInterest)
        return totalInterest;
    }

    const calculateFinanceValues = (car, taxFees, tax) => {
        const dpAmount = 0.1;
        let fees = car?.fees?.reduce((total, item) => total + item.cost, 0) || 0;
        let interestCharge = calculateFinanceInterest(car, dpAmount);
    
        let monthlyPayment, downPayment;
    
        if (taxFees) {
            monthlyPayment = ((((car.discounted_msrp + interestCharge - (car.discounted_msrp * dpAmount)) * (1 + tax)) + fees) / car.finance_term_length).toFixed(2);
            downPayment = (car.discounted_msrp * dpAmount).toFixed(2);
        } else {
            monthlyPayment = (((car.discounted_msrp - (car.discounted_msrp * dpAmount)) / car.finance_term_length).toFixed(2));
            downPayment = (car.discounted_msrp * dpAmount).toFixed(2);
        }
    
        // Set the values to props
        props.setFinanceMonthly(monthlyPayment);
        props.setFinanceDown(downPayment);
    }
    

    const handleNoTaxFees = () => {
        if (props.includeTaxFees)
        {
            props.setIncludeTaxFees(false)
            calculateLeaseValues(props.car, false, 0)
            calculateFinanceValues(props.car, false, 0)
            localStorage.setItem('includeTaxFees', false)
        }
        else
        {
            if (localStorage.getItem('tax') !== undefined && localStorage.getItem('tax') !== null)
            {
                props.setIncludeTaxFees(true)
                calculateLeaseValues(props.car, true, (localStorage.getItem('tax') / 100))
                calculateFinanceValues(props.car, true, (localStorage.getItem('tax') / 100))
                localStorage.setItem('includeTaxFees', true)
            }
            else
            {
                localStorage.setItem('includeTaxFees', true)
                props.setTaxFeeModal(true)
            }
        }
    }

    const calculateTotalDiscounts = (car) => {
        if (car === '') {return 0}
        let total = 0
        car?.discounts.map((item) => {
            total = total + item.price;
        })
        return total;
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: 'auto', fontFamily: 'inter', color: window.colors.primary, ...props.style, width: window.innerWidth < 1500 && '98%', marginLeft: window.innerWidth < 1500 && 'auto', marginRight: window.innerWidth < 1500 && 'auto', alignItems: window.innerWidth < 1500 && 'center'}}>
            <span style={{fontWeight: '700', fontSize: '32px'}}>Discount Breakdown</span>
            <div style={{display: 'flex', flexDirection: window.innerWidth < 1500 ? 'column':'row', width: window.innerWidth < 1500 && '95%', marginTop: '0px'}}>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '20px', marginLeft: window.innerWidth < 1500 && 'auto', marginRight: window.innerWidth < 1500 && 'auto', marginTop: window.innerWidth < 900 && '30px', borderRadius: '10px', color: window.colors.primary, width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: window.innerWidth < 900 ? 'column':'row', borderBottom: '1px solid ' + window.colors.primary}}>
                        <span className='noSelect' style={{fontWeight: '500', marginBottom: '20px', marginTop: '5px'}}>Some rebates & incentives you must qualify for. If you do not qualify, this amount will be added to the lease.</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: window.innerWidth < 900 ? 'column':'row', color: window.colors.primary, marginTop: '15px'}}>
                        {props?.car?.discounts?.map((dis, index) => {
                            if (!dis.name || !dis.price) return null;
                            return (
                            <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px', borderLeft: window.innerWidth < 650 && '1px solid ' + window.colors.white, backgroundColor: '#EDEDEF', padding: '15px', borderRadius: '10px', marginRight: '20px', width: '90%', maxWidth: window.innerWidth < 8900 ? '100%':'167px'}}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <span style={{fontWeight: '600', color: window.colors.primary, fontSize: '16px', marginRight: 'auto'}}>{dis.name}</span>
                                    <div className="center" onMouseEnter={() => setNoticePopup(index)} onMouseLeave={() => setNoticePopup(-1)} style={{ fontWeight: '500', fontSize: '16px', backgroundColor: window.colors.primary, borderRadius: '100px', color: window.colors.white, width: '20px', height: '20px', cursor: 'pointer', position: 'relative', marginLeft: '10px' }}>
                                        <span>?</span>
                                        <Tooltip style={{left: window.innerWidth < 900 ? '-300px':'-150px'}} text={(dis.note === undefined || dis.note === '') ? "No Requirement":dis.note} isVisible={noticePopup === index}/>
                                    </div>
                                </div>
                                <span style={{fontWeight: '400', fontSize: '16px', marginTop: 'auto', paddingTop: '5px'}}>-${window.addCommas(dis.price)}</span>
                            </div>
                            )
                        })}  
                    </div>
                </div>
            </div>
            {/* <motion.a href='#priceBreakdown' whileHover={window.bAnim} style={{backgroundColor: window.colors.primary, color: window.colors.white, padding: '15px 25px 15px 25px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: '500', fontFamily: 'inter', marginTop: '20px', width: '250px', textDecoration: 'none', textAlign: 'center'}}>View Full Price Breakdown</motion.a> */}
        </div>
    );
}

const Tooltip = ({ text, isVisible, style }) => (
    <AnimatePresence>
        {isVisible && (
            <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
                style={{
                    position: 'absolute',
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    zIndex: 150,
                    width: '300px',
                    left: '-150px',
                    fontWeight: '400',
                    ...style,
                }}
            >
                {text}
            </motion.div>
        )}
    </AnimatePresence>
);

export default Main;
